import { useEffect, useRef, useState } from "react";

import type { EmailVerificationStep } from "../types";

interface UseHeightTransitionProps {
  currentStep: EmailVerificationStep;
}

export const useHeightTransition = ({
  currentStep,
}: UseHeightTransitionProps) => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [currentHeight, setCurrentHeight] = useState<number | undefined>(
    undefined,
  );
  const [displayedStep, setDisplayedStep] = useState(currentStep);
  const contentRef = useRef<HTMLDivElement>(null);

  // Track height changes and manage transitions
  useEffect(() => {
    if (currentStep !== displayedStep && contentRef.current) {
      setIsTransitioning(true);
      setCurrentHeight(contentRef.current.offsetHeight);

      setTimeout(() => {
        setDisplayedStep(currentStep);

        setTimeout(() => {
          if (contentRef.current) {
            const newHeight = contentRef.current.scrollHeight;
            setCurrentHeight(newHeight);

            setTimeout(() => {
              setIsTransitioning(false);
              setCurrentHeight(undefined);
            }, 300);
          }
        }, 50);
      }, 200);
    }
  }, [currentStep, displayedStep]);

  return {
    isTransitioning,
    currentHeight,
    displayedStep,
    contentRef,
  };
};
